export default {
	
	order: ['$stateParams', '$state', function ($stateParams,$state) {
		return   $stateParams.order ||'desc';
	}],
	offset: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.offset || 0;
	}],
	name: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.name || '';
	}],
};



// WEBPACK FOOTER //
// ./src/page/productsRating/productsRating.resolve.js